import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './References.css';

const References: React.FC = () => {
  const { t } = useTranslation();
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  // Tanıtım videoları - tüm videolar
  const videos = [
    { id: 0, src: '/consolting_madeby_top.webm', title: 'UstaConsulting Tanıtım' },
    { id: 1, src: '/video1.mp4', title: 'Tanıtım Video 1' },
    { id: 2, src: '/video2.mp4', title: 'Tanıtım Video 2' },
    { id: 3, src: '/video3.mp4', title: 'Tanıtım Video 3' },
    { id: 4, src: '/video4.mp4', title: 'Tanıtım Video 4' },
    { id: 5, src: '/video5.mp4', title: 'Tanıtım Video 5' },
    { id: 6, src: '/video6.mp4', title: 'Tanıtım Video 6' },
    { id: 7, src: '/video7.mp4', title: 'Tanıtım Video 7' },
    { id: 8, src: '/video8.mp4', title: 'Tanıtım Video 8' },
    { id: 9, src: '/video9.mp4', title: 'Tanıtım Video 9' },
    { id: 10, src: '/video10.mp4', title: 'Tanıtım Video 10' },
  ];

  // Videoları iki kez tekrarlıyoruz sonsuz kayma efekti için
  const doubledVideos = [...videos, ...videos];

  useEffect(() => {
    // Tüm videoları otomatik oynat ve hızını 1.5x yap
    videoRefs.current.forEach(video => {
      if (video) {
        video.playbackRate = 1.5;
        video.play().catch(() => {});
      }
    });
  }, []);

  return (
    <section className="video-showcase">
      <div className="container">
        <motion.div
          className="video-showcase-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="video-showcase-title">{t('videoShowcase.title')}</h2>
          <p className="video-showcase-subtitle">{t('videoShowcase.subtitle')}</p>
          <span className="video-showcase-ai-badge">🤖 {t('videoShowcase.ai')}</span>
        </motion.div>
      </div>

      <div className="video-slider">
        <div className="video-track">
          {doubledVideos.map((video, index) => (
            <div key={index} className="video-item">
              <video
                ref={el => videoRefs.current[index] = el}
                src={video.src}
                muted
                loop
                playsInline
                autoPlay
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default References;
